import React, { Component } from 'react';
import { LargeBusiness } from '../../Constants';
import EirButton from '../eir-button/EirButton';

class ScrollToTop extends Component {
  scrollBackToTop() {
    let scrollStep = -window.pageYOffset / (1000 / 15);
    let scrollInterval = setInterval(function() {
        if (window.pageYOffset != 0) {
          window.scrollBy(0, scrollStep);

        } else clearInterval(scrollInterval);
      }, 15);
  }
  render() {
    const iconScroll= LargeBusiness.isLBSite? "icon-scroll_up--white":"icon-arrowup--black";
    return (
      <div className="col-sm-12 col-md-12 text-md-right text-center scroll-to-top">
        <span className={`eir-icon eir-icon--sm ${iconScroll} mr-1`} onClick={LargeBusiness.isLBSite?this.scrollBackToTop:""} style={{cursor:"pointer"}} />
        <EirButton
          onClick={this.scrollBackToTop}
          text={LargeBusiness.isLBSite?'Back to top':'Back to the top'}
          className={'a-no-style'}
          role='link'
          ariaLabel="back to the top of the page main navigation eir logo"  
        />
      </div>
    );
  }
}

export default ScrollToTop;
